import { Component, OnInit } from '@angular/core';
import { RemitaModel } from '../model/remita.model';
import { RemitaPaymentService } from './remita-payment.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-remita',
  templateUrl: './remita.component.html',
  styleUrls: ['./remita.component.css']
})
export class RemitaComponent implements OnInit {

  remita: RemitaModel | any;
  paymentInfo: any;
  isLoading: boolean = true;
  baseUrl: string = "";
  responseUrl: string = "";
  errorMessage:string = null;

  constructor(private remitaPaymentService: RemitaPaymentService) {
    this.responseUrl = sessionStorage.getItem('responseurl');
    this.baseUrl = environment.baseURL;
    this.paymentInfo = this.remitaPaymentService.paymentInfo;
    this.generateRRR();
  }


  ngOnInit(): void {
  }


  generateRRR() {
    this.isLoading = true;
    let request = {
      totalAmount: this.paymentInfo.totalAmount,
      entityId: this.paymentInfo.persistMasterId,
      processTypeId: this.paymentInfo.processTypeId,
      entityName: this.paymentInfo.entityName,
      feeDescription: this.paymentInfo.paymentDue[0].name,
      returnBackUrl: this.responseUrl || environment.baseURL+"/payment-history"
    }

    this.remitaPaymentService.generateRRR(request).subscribe(
      response => {
        this.isLoading = false;
        if (response.status == "OK") {
          this.remita = response.data;
          this.remita.responseurl = this.responseUrl ? this.responseUrl : this.remita.responseurl;
        }
        else {
          this.errorMessage = response.message;
        }
      },
      error => {
        this.errorMessage = `Remita Generate RRR error: ${error}`;
        console.info(`Remita Generate RRR error: ${error}`);
      });
  }

  goBack(){
    window.history.back();
  }

}
